export default function SocialMediaCard({ platform, followers, icon: Icon, bgColor, iconColor }) {
  const formatFollowers = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(2) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toString();
  };

  return (
    <div
      className={`card-wrapper !p-4 !rounded-2xl relative hover:scale-105 transition-transform cursor-pointer`}
    >
      <div className="relative z-10">
        <div className={`${iconColor} mb-4`}>
          <Icon className="w-8 h-8" />
        </div>
        <div className="text-black">
          <div className="text-sm font-medium mb-1">{platform}</div>
          <div className="text-2xl font-bold">{formatFollowers(followers)}</div>
          <div className="text-xs opacity-80 mt-1">Followers</div>
        </div>
      </div>
      <div className="absolute -right-4 -bottom-4 opacity-10">
        <Icon className="w-32 h-32" />
      </div>
    </div>
  );
}
